module.exports = __webpack_public_path__ + "static/media/icon-right-chevron.83e06ca1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/product-detail/image-carousel/icon-right-chevron.svg
// module id = 999
// module chunks = 1